import React, { useState, useEffect } from "react"
import styled from "styled-components"

import useInput from "./useInput"
import getFirebase, { firebaseConfig } from "../../firebase"
import { H1, tagLine, textButton } from "../Styles/TextStyles"
import firebase from "firebase"
import { Link } from "gatsby"
import signUpBackground from "../backgrounds/signUpBackground"

const SignUpForm = () => {
  var [signedIn, isAuthenticated] = useState(Boolean)
  var [getEmail, userEmail] = useState("")
  var [getUID, userUID] = useState("")
  var [getDisplayName, displayName] = useState("Set Display Name")
  const email = useInput("")
  const password = useInput("")

  const signUp = async () => {
    if (email.value != "" && password.value != "") {
      try {
        if (getFirebase()) {
          const user = await getFirebase()
            .auth()
            .createUserWithEmailAndPassword(email.value, password.value)
          console.log("user", user)
          alert(`Welcome ${email.value}!`)
          signedIn = true
        }
      } catch (error) {
        console.log("error", error)
        alert(error.message)
      }
    } else {
      alert(
        `${
          email.value == "" ? "Please Enter Email!" : "Please enter a Password!"
        }`
      )
    }
    try {
      if (getFirebase()) {
        const newUser = getFirebase().auth().currentUser
        getEmail = newUser.email
        getUID = newUser.uid
        getDisplayName = newUser.displayName
      }
    } catch (error) {
      console.log("error", error)
    }
  }
  const signOut = async () => {
    try {
      if (getFirebase()) {
        const user = await getFirebase().auth().signOut()
        console.log("user", user)
        alert(`Sign Out Successfully!`)
        signedIn = false
      }
    } catch (error) {
      console.log("error", error)
      alert(error.message)
    }
  }

  // const getUserDetails = async () => {
  //   try {
  //     if (getFirebase()) {
  //       const user = await getFirebase().auth().currentUser

  //       getEmail = user.email
  //       getUID = user.uid
  //       getDisplayName = user.displayName
  //     }
  //   } catch (error) {
  //     console.log("error", error)
  //   }
  // }

  return (
    <Total>
      <Wrapper>
        <FormWrapper onSubmit={event => signUp(event.preventDefault())}>
          <Title>Sign up</Title>
          <Input placeholder="Email" {...email} color="white" />
          <Input placeholder="Password" type="password" {...password} />
          <Button type="submit">Sign up</Button>
        </FormWrapper>
        {isAuthenticated === true && (
          <div>
            <tagLine>UID: {userUID}</tagLine>
            <tagLine>Email: {userEmail}</tagLine>
            <tagLine>Display Name: {displayName}</tagLine>
          </div>
        )}
        {isAuthenticated === true && (
          <Button onClick={signOut()}>Sign Out</Button>
        )}

        <AlreadyMember>
          Already a member? <Link to="/signIn">Sign In</Link>
        </AlreadyMember>
      </Wrapper>

      <Background />

      <Image src="../PM/pink-wave.svg" />
    </Total>
  )
}

export default SignUpForm

const Background = styled.div`
  background: linear-gradient(102.1deg, #11f1ff 0%, #ad00ff 100%);
  position: absolute;
  top: -300px;
  z-index: -1;
  width: 1334px;
  height: 600px;
`
const Image = styled.img`
  position: relative;
  top: -100px;
  z-index: -1;
`

const Total = styled.div`
  align-self: center;
  align-items: center;
  align-content: center;
  max-width: 1334px;
  overflow: hidden;
`

const FormWrapper = styled.form`
  display: grid;
  justify-content: center;
  gap: 20px;
  padding-bottom: 50px;
  z-index: 1;
  transition: cubic-bezier(0.175, 0.885, 0.32, 1.275);
`
const Wrapper = styled.div`
  display: grid;
  grid-template-rows: auto auto;
`

const AlreadyMember = styled(H1)`
  font-size: 20px;
  color: white;
  text-align: center;
  z-index: 1;
`

const Title = styled.h1`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 48px;
  color: #000;
  text-align: center;
  z-index: 1;
`

const Input = styled.input`
  width: 200px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 30px;
  padding: 10px 20px;
  background-blend-mode: overlay;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0px 20px 40px rgba(31, 47, 71, 0.25),
    0px 1px 5px rgba(0, 0, 0, 0.1), inset 0 0 0 0.5px rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(250, 250, 250, 0.4);
  color: white;
  font-weight: bold;
  font-size: 15px;
  ::placeholder {
    color: white;
    font-weight: bold;
    font-size: 15px;
    opacity: 0.5;
  }

  :focus {
    outline: none;
  }
  z-index: 1;
`

const Button = styled.button`
  background: linear-gradient(91.4deg, #2fb8ff 0%, #9eecd9 100%);
  padding: 12px 0;
  width: 200px;
  border: none;
  border-radius: 30px;
  color: white;
  font-weight: bold;
  font-family: Segoe UI, sans-serif;
  font-size: 15px;
  cursor: pointer;

  :focus {
    outline: none;
  }
  z-index: 1;
`
